import { CardBinsResponse } from 'types/api/card-bins';
import { FetchResponse } from 'types/fetch';
import endpoints from '../endpoints';
import fetchReq from '../fetch';

export default function fetchCardBins(): FetchResponse<CardBinsResponse> {
  return fetchReq({
    mark: 'card_bins',
    method: 'GET',
    url: endpoints.cardMetadataSvc.cardBins
  });
}
